// extracted by mini-css-extract-plugin
module.exports = {"root":"CourseDetails_root__LUIXp","courseDetailsWrapper":"CourseDetails_courseDetailsWrapper__1d1g3","rightColumn":"CourseDetails_rightColumn__y5qhv"};